import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "e0dfeb8b-e5a3-4708-a38b-daf3d9a6b4c0", content: "Have a perfect noise-free environment.", options: {} },
  { id: "86d26b9e-d9a1-4606-8843-c258af4242f0", content: "Hear the response of the hall.", options: {} },
  {
    id: "a31a73a3-9bd8-4987-8e56-f99342e5fdbc",
    content: "Sit at a distance of at least 2 meters away from one another.",
    options: {},
  },
  { id: "261d8528-498e-4ebb-b59f-40a3ecb6a314", content: "Hear each other well.", options: {} },
];

export const task: Task = {
  id: "21a57c13-b026-4ebb-90bb-3ff2f8edde65",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["86d26b9e-d9a1-4606-8843-c258af4242f0", "261d8528-498e-4ebb-b59f-40a3ecb6a314"],
};
